export const colors = {
    setUiColor(colorPrimary: string | undefined, backgroundColor: string | undefined) {
        const root = document.querySelector(":root") as HTMLElement;
        root.style.setProperty("--colorPrimary", colorPrimary == null ? "#8fb52c" : colorPrimary);
        root.style.setProperty(
            "--colorPrimaryHover",
            colorPrimary == null ? "#a6c455" : this.lightenColor(colorPrimary, 15)
        );
        root.style.setProperty("--headerBackgroundColor", backgroundColor == null ? "#fff" : backgroundColor);
        root.style.setProperty("--backgroundColor", backgroundColor == null ? "#484848" : backgroundColor);
    },

    lightenColor(color: string, percentage: number): string {
        const hex = color.replace(/[^0-9a-f]/gi, "");
        const num = parseInt(hex, 16);
        const amt = Math.round(2.55 * percentage);
        const R = (num >> 16) + amt;
        const G = ((num >> 8) & 0x00ff) + amt;
        const B = (num & 0x0000ff) + amt;
        const newColor = (
            0x1000000 +
            (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
            (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
            (B < 255 ? (B < 1 ? 0 : B) : 255)
        )
            .toString(16)
            .slice(1);
        return `#${newColor}`;
    },
};
